export enum OperationState {
  CREATED = 'CREATED',
  IN_PROGRESS = 'IN_PROGRESS',
  PENDING = 'PENDING',
  TO_PROCESS = 'TO_PROCESS',
  ACCEPTED = 'ACCEPTED',
  CONFIRMED = 'CONFIRMED',
  REFUSED = 'REFUSED',
  CANCELED = 'CANCELED',
  CONTESTED = 'CONTESTED',
  EXPIRED = 'EXPIRED',
  FINALIZED = 'FINALIZED',
  REALIZED = 'REALIZED',
  BILLED = 'BILLED',
}
